export default "__VITE_ASSET__dc32ba8d__"